import { SxProps, Theme } from '@mui/material';

// TODO: use colors from theme once ROBO2-159 is merged
export const styles: Record<'button' | 'avatar', SxProps<Theme>> = {
  avatar: {
    '&:hover': {
      background: (theme) => theme.palette.primary[500],
      color: 'black',
    },
    background: (theme) => theme.palette.gray[400],
  },
  button: {
    borderRadius: '50%',
    height: '40px',
    padding: 0,
    width: '40px',
  },
};
